<template>
  <header class="board-header" :class="{ 'board-header--menu': showMenu }">
    <button
      v-if="showMenu"
      :aria-expanded="appStore.isMenuOpen"
      aria-label="切换菜单"
      class="board-header__menu"
      type="button"
      @click="appStore.toggleMenu()"
    >
      <i aria-hidden="true" class="icon-list-sort-descending t-iconfont"></i>
    </button>
    <button v-else aria-label="返回" class="board-header__back" type="button" @click="handleBack">
      <i class="icon-arrow-left-s-line t-iconfont"></i>
    </button>
    <span class="board-header__title" :title="title">{{ title }}</span>
    <div v-if="$slots.right" class="board-header__right">
      <slot name="right" />
    </div>
  </header>
</template>

<script setup>
import { computed, inject, onActivated, onDeactivated, onMounted, onUnmounted } from 'vue'
import { useRouter, viewDepthKey } from 'vue-router'
import { useAppStore } from '@/store/useAppStore'
import {
  goMobilePageBack,
  mobilePageNavigationKey
} from '@/components/router-entry/common/mobilePageNavigation'

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  showMenu: {
    type: Boolean,
    default: true
  }
})

const appStore = useAppStore()
const router = useRouter()
const navigation = inject(mobilePageNavigationKey, null)
const header = {
  showMenu: computed(() => props.showMenu),
  depth: inject(viewDepthKey, 0)
}
let unregisterHeader = null

const registerHeader = () => {
  if (!unregisterHeader && navigation) unregisterHeader = navigation.registerHeader(header)
}
const releaseHeader = () => {
  unregisterHeader?.()
  unregisterHeader = null
}

onMounted(registerHeader)
onActivated(registerHeader)
onDeactivated(releaseHeader)
onUnmounted(releaseHeader)

const handleBack = () => {
  if (navigation) navigation.goBack()
  else goMobilePageBack(router)
}
</script>

<style lang="scss" scoped>
.board-header {
  user-select: none;
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 56px;
  padding: 0 16px;

  &--menu {
    box-sizing: border-box;
    overflow: hidden;
  }

  &__menu {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 24px;
    height: 24px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #4e5969;
    font-size: 24px;
    line-height: 24px;
    cursor: pointer;

    .t-iconfont {
      font-size: inherit;
      line-height: inherit;
    }
  }

  &__back {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 24px;
    height: 24px;
    padding: 0;
    border: 0;
    color: #323233;
    background: transparent;

    .t-iconfont {
      font-size: 24px;
    }
  }

  &__title {
    flex: 1;
    min-width: 0;
    margin: 0 24px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #242832;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    text-align: center;
  }

  &__right {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 0 0 auto;
  }
}
</style>
